import { PollingStatus } from "@/types/PollingStatus";

export interface UserContextState {
	tenantOverview: TenantOverview,
	pollingStatus: PollingStatus,
	isSet: boolean
}

export interface TenantOverview {
	areaCount: number,
	groupMaskingOverview: GroupMaskingOverview
}

export interface GroupMaskingOverview {
	maskedCount: number,
	partialMaskCount: number
	unmaskedCount: number,
}

export enum TenantSize {
	Small = "small",
	Medium = "medium",
	Large = "large"
}
